import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../../services/api';
import {
  Button,
  ButtonsContainer,
  Container,
  Content,
  ContentWrapper,
  SubTitle,
  Title,
  Wrapper,
} from './styles';
import { setAcceptedTerms } from '../../store/auth/actions';
import { persistor } from '../../store';
import { navigationUrl } from '../../store/analytic/actions';

const Terms: React.FC = () => {
  const dispatch = useDispatch();
  const terms = useSelector(
    (state: ApplicationState) => state.config.termosUso
  );
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [reachedEnd, setReachedEnd] = useState(false); // Nova variável de estado
  const history = useHistory();

  const termsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (termsRef.current) {
      termsRef.current.innerHTML = terms;
      const isAtEnd =
        Math.ceil(termsRef.current.scrollHeight - termsRef.current.scrollTop) <=
        termsRef.current.clientHeight + 1;
      if (isAtEnd) {
        setReachedEnd(true);
      }
      setButtonDisabled(!reachedEnd && !isAtEnd);
    }
  }, [terms, reachedEnd]);

  useEffect(() => {
    const handleScroll = () => {
      if (!termsRef.current) return;
      const isAtEnd =
        Math.ceil(termsRef.current.scrollHeight - termsRef.current.scrollTop) <=
        termsRef.current.clientHeight + 1;
      if (isAtEnd) {
        setReachedEnd(true);
      }
    };

    termsRef.current?.addEventListener('scroll', handleScroll);
    termsRef.current?.addEventListener('wheel', handleScroll);

    return () => {
      termsRef.current?.removeEventListener('scroll', handleScroll);
      termsRef.current?.removeEventListener('wheel', handleScroll);
    };
  }, [termsRef, reachedEnd]);

  useEffect(() => {
    dispatch(
      navigationUrl.request({
        action: '/termosUso',
      })
    );
  }, [dispatch]);

  const [mobile, setMobile] = useState(false);
  useEffect(() => {
    const query = '(min-width: 500px)';
    const handler = (e: MediaQueryListEvent) => setMobile(e.matches);
    const matcher = window.matchMedia(query);
    matcher.addEventListener('change', handler);
    setMobile(matcher.matches);
    return () => matcher.removeEventListener('change', handler);
  }, []);

  const handleBack = () => {
    persistor.purge();
  };
  const handleAcceptTerms = () => {
    api
      .acceptTerms()
      .then(() => {
        dispatch(setAcceptedTerms(true));
        history.push('/contrato');
      })
      .catch((err) => toast.error(err.message));
  };

  return (
    <Wrapper>
      <Container>
        <Title>Termos de uso</Title>
        <SubTitle>
          Leia atentamente os Termos e Condições, após concordar clicando no
          botão ao final dos termos você poderá prosseguir.
        </SubTitle>
        <ContentWrapper>
          <Content ref={termsRef}>
            <p>Carregando...</p>
          </Content>
        </ContentWrapper>
        <ButtonsContainer>
          <Button className='normal' onClick={handleBack}>
            CANCELAR
          </Button>
          <Button
            onClick={handleAcceptTerms}
            disabled={!reachedEnd}
            className='agree'
            title={!reachedEnd ? 'Favor ler todo o documento' : ''}
          >
            CONCORDAR{mobile && ' E CONTINUAR'}
          </Button>
        </ButtonsContainer>
      </Container>
    </Wrapper>
  );
};

export default Terms;
